import axios from 'axios';

import url from '../../components/common/BaseURL';

const baseURL = url.baseURL;


export const fetchUserList = (user) => {
    return (dispatch) => {
        dispatch({ type: 'FETCH_USER_LIST' });
        axios.get(baseURL + 'users', {
            params: {
                token: user.token,
                user_id: user.user_id,
                user_type: 'admin'
            }
        }).then(response => {
            console.log(response);
            dispatch({ type: 'FETCH_USER_LIST_SUCCESS', payload: response.data.data });
        }).catch(err => {
            dispatch({ type: 'FETCH_USER_LIST_FAIL' });
            console.log(err);
        });
    };
};



// WEBPACK FOOTER //
// ./src/actions/UserDetails/UserAction.js